import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EOpenNewQuestionForm {
  Open = 'NEW_QUESTION/FORM/OPEN',
  Close = 'NEW_QUESTION/FORM/CLOSE',
}

export type TOpenNewQuestion = ITypedReduxAction<EOpenNewQuestionForm.Open>;
export type TCloseNewQuestion = ITypedReduxAction<EOpenNewQuestionForm.Close>;

export type TOpenNewQuestionFormActions = TOpenNewQuestion | TCloseNewQuestion;
